import initialState from './initialstate';
import * as types from '../actions/actiontypes';

export function setFormV2ToasterVisibilityReducer(state = initialState.toasterDetails, action) {
	switch (action.type) {
		case types.SET_TOASTER_VISIBILITY: {
			const {showToaster} = action.payload;

			if (showToaster === false) {
				return {};
			} else {
				return action.payload;
			}
		}
		default:
			return state;
	}
}
